import { render, staticRenderFns } from "./SideBarCorporate.vue?vue&type=template&id=0ec06ff8&"
import script from "./SideBarCorporate.vue?vue&type=script&lang=ts&"
export * from "./SideBarCorporate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports